import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '../../services/app.service';


@Component({
  selector: 'app-user-update-dialog',
  templateUrl: './user-update-dialog.component.html',
  styleUrls: ['./user-update-dialog.component.css']
})
export class UserUpdateDialogComponent {


  phoneForm: FormGroup;
  buffer = false;

  constructor(
    private appService: AppService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UserUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.phoneForm = this.fb.group({
      phoneNumber: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]]
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onUpdate(): void {

    if (this.phoneForm.valid) {
      this.buffer = true;
      this.appService.updatePhoneNumber(this.phoneForm.value.phoneNumber, this.data.userKey).subscribe(
        (res: any) => {
          this.buffer = false;
          this.dialogRef.close(true);
        },
        error => {
          console.log("error", error);
          this.buffer = false;
          this.dialogRef.close(false);
        });
    }
  }


}
